import { useEffect } from 'react';

/**
 * Custom hook to scroll to top of page when component mounts
 * Use this on every page to ensure users always start at the top
 */
export function useScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
}
